import { shareColumnsExtend, shareFormColumnsExtend } from './share';
export const PRODUCT_DESIGN_DESIGN_TYPES = [
  'custom',
  'men',
  'women',
]

export const PRODUCT_DESIGN_STATES = [
  'init',
  'pending',
  'wait_confirm',
  'making',
  'completed',
  'rejected',
  'wait_sales_director_audit',
  'sales_director_rejected',
  'receive_fabric_and_assist_confirmed',
  'making_plate',
  'make_plate_completed',
  'make_plate_rejected',
  'cutting',
  'crafting',
  'craft_completed',
  'cut_rejected',
  'sewing',
  'sew_completed',
  'sew_rejected',
  'quantity_audited',
  'wait_confirm_craft',
  'craft_rejected',
  'wait_confirm_make_plate',
  'plate_approved',
  'signed_sample',
  'wait_audit_quantity',
]

export const PRODUCT_DESIGN_PATTERN_FACTORIES = [
  'pattern',
  'cooperative_pattern',
  'semi_finished_pattern',
]

export const PRODUCT_DESIGN_PLATE_MAKING_TYPES = [
  'original',
  'reproduction',
  'pre_production',
  'fabric_craft',
  'paper_pattern',
  'pre_quotation',
]

export const PRODUCT_DESIGN_ACCESSORY_STATES = [
  'unknown',
  'needless',
  'pending',
  'confirmed',
  'completed',
]

export const PRODUCT_DESIGN_FABRIC_STATES = [
  'unknown',
  'needless',
  'pending',
  'confirmed',
  'completed',
]

const entityColumns = {
  id: {
    model_name: 'ProductDesign',
    column_type: 'id',
    label_key_path: 'productDesign.id',
  },
  created_at: {
    model_name: 'ProductDesign',
    column_type: 'datetime',
    label_key_path: 'productDesign.createdAt',
  },
  updated_at: {
    model_name: 'ProductDesign',
    column_type: 'datetime',
    label_key_path: 'productDesign.updatedAt',
  },
  number: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.number',
  },
  overdue_reason: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.overdueReason',
  },
  reject_reason: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.rejectReason',
  },
  remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.remark',
  },
  cheif_pattern_making_officier: {
    model_name: 'ProductDesign',
    column_type: 'belongs_to',
    label_key_path: 'productDesign.cheifPatternMakingOfficier',
    extra: {
      association_name: 'cheif_pattern_making_officier',
      model_name: 'User',
      foreign_key: 'cheif_pattern_making_officier_id',
      display_column: 'screen_name',
    },
  },
  cheif_pattern_making_officier_id: {
    model_name: 'ProductDesign',
    column_type: 'belongs_to',
    label_key_path: 'productDesign.cheifPatternMakingOfficier',
    extra: {
      association_name: 'cheif_pattern_making_officier',
      model_name: 'User',
      foreign_key: 'cheif_pattern_making_officier_id',
      display_column: 'screen_name',
    },
  },
  design_type: {
    model_name: 'ProductDesign',
    column_type: 'enum',
    extra: {
      options: ['custom', 'men', 'women'],
    },
    label_key_path: 'productDesign.designType',
  },
  designer: {
    model_name: 'ProductDesign',
    column_type: 'belongs_to',
    label_key_path: 'productDesign.designer',
    extra: {
      association_name: 'designer',
      model_name: 'User',
      foreign_key: 'designer_id',
      display_column: 'screen_name',
    },
  },
  designer_id: {
    model_name: 'ProductDesign',
    column_type: 'belongs_to',
    label_key_path: 'productDesign.designer',
    extra: {
      association_name: 'designer',
      model_name: 'User',
      foreign_key: 'designer_id',
      display_column: 'screen_name',
    },
  },
  pattern_maker: {
    model_name: 'ProductDesign',
    column_type: 'belongs_to',
    label_key_path: 'productDesign.patternMaker',
    extra: {
      association_name: 'pattern_maker',
      model_name: 'User',
      foreign_key: 'pattern_maker_id',
      display_column: 'screen_name',
    },
  },
  pattern_maker_id: {
    model_name: 'ProductDesign',
    column_type: 'belongs_to',
    label_key_path: 'productDesign.patternMaker',
    extra: {
      association_name: 'pattern_maker',
      model_name: 'User',
      foreign_key: 'pattern_maker_id',
      display_column: 'screen_name',
    },
  },
  state: {
    model_name: 'ProductDesign',
    column_type: 'enum',
    extra: {
      options: ['init', 'pending', 'wait_confirm', 'making', 'completed', 'rejected', 'wait_sales_director_audit', 'sales_director_rejected', 'receive_fabric_and_assist_confirmed', 'making_plate', 'make_plate_completed', 'make_plate_rejected', 'cutting', 'crafting', 'craft_completed', 'cut_rejected', 'sewing', 'sew_completed', 'sew_rejected', 'quantity_audited', 'wait_confirm_craft', 'craft_rejected', 'wait_confirm_make_plate', 'plate_approved', 'signed_sample', 'wait_audit_quantity'],
    },
    label_key_path: 'productDesign.state',
  },
  publication_on: {
    model_name: 'ProductDesign',
    column_type: 'date',
    label_key_path: 'productDesign.publicationOn',
  },
  sales_director_audited_at: {
    model_name: 'ProductDesign',
    column_type: 'datetime',
    label_key_path: 'productDesign.salesDirectorAuditedAt',
  },
  audited_at: {
    model_name: 'ProductDesign',
    column_type: 'datetime',
    label_key_path: 'productDesign.auditedAt',
  },
  completed_at: {
    model_name: 'ProductDesign',
    column_type: 'datetime',
    label_key_path: 'productDesign.completedAt',
  },
  confirmed_at: {
    model_name: 'ProductDesign',
    column_type: 'datetime',
    label_key_path: 'productDesign.confirmedAt',
  },
  plan_completed_on: {
    model_name: 'ProductDesign',
    column_type: 'datetime',
    label_key_path: 'productDesign.planCompletedOn',
  },
  company: {
    model_name: 'ProductDesign',
    column_type: 'belongs_to',
    label_key_path: 'productDesign.company',
    extra: {
      association_name: 'company',
      model_name: 'Company',
      foreign_key: 'company_id',
      display_column: 'name',
    },
  },
  company_id: {
    model_name: 'ProductDesign',
    column_type: 'belongs_to',
    label_key_path: 'productDesign.company',
    extra: {
      association_name: 'company',
      model_name: 'Company',
      foreign_key: 'company_id',
      display_column: 'name',
    },
  },
  supplier: {
    model_name: 'ProductDesign',
    column_type: 'belongs_to',
    label_key_path: 'productDesign.supplier',
    extra: {
      association_name: 'supplier',
      model_name: 'User',
      foreign_key: 'supplier_id',
      display_column: 'screen_name',
    },
  },
  supplier_id: {
    model_name: 'ProductDesign',
    column_type: 'belongs_to',
    label_key_path: 'productDesign.supplier',
    extra: {
      association_name: 'supplier',
      model_name: 'User',
      foreign_key: 'supplier_id',
      display_column: 'screen_name',
    },
  },
  pattern_factory: {
    model_name: 'ProductDesign',
    column_type: 'enum',
    extra: {
      options: ['pattern', 'cooperative_pattern', 'semi_finished_pattern'],
    },
    label_key_path: 'productDesign.patternFactory',
  },
  receive_pattern_on: {
    model_name: 'ProductDesign',
    column_type: 'date',
    label_key_path: 'productDesign.receivePatternOn',
  },
  receive_pattern_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.receivePatternRemark',
  },
  receive_fabric_and_assist_on: {
    model_name: 'ProductDesign',
    column_type: 'date',
    label_key_path: 'productDesign.receiveFabricAndAssistOn',
  },
  process_start_on: {
    model_name: 'ProductDesign',
    column_type: 'date',
    label_key_path: 'productDesign.processStartOn',
  },
  sewing_start_on: {
    model_name: 'ProductDesign',
    column_type: 'date',
    label_key_path: 'productDesign.sewingStartOn',
  },
  completed_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.completedRemark',
  },
  plan_completed_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.planCompletedRemark',
  },
  pattern_type: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.patternType',
  },
  fabric_cost: {
    model_name: 'ProductDesign',
    column_type: 'decimal',
    label_key_path: 'productDesign.fabricCost',
  },
  craft_cost: {
    model_name: 'ProductDesign',
    column_type: 'decimal',
    label_key_path: 'productDesign.craftCost',
  },
  processing_cost: {
    model_name: 'ProductDesign',
    column_type: 'decimal',
    label_key_path: 'productDesign.processingCost',
  },
  assist_cost: {
    model_name: 'ProductDesign',
    column_type: 'decimal',
    label_key_path: 'productDesign.assistCost',
  },
  management_cost: {
    model_name: 'ProductDesign',
    column_type: 'decimal',
    label_key_path: 'productDesign.managementCost',
  },
  fob_profit: {
    model_name: 'ProductDesign',
    column_type: 'decimal',
    label_key_path: 'productDesign.fobProfit',
  },
  management_fee: {
    model_name: 'ProductDesign',
    column_type: 'decimal',
    label_key_path: 'productDesign.managementFee',
  },
  inspection_fee: {
    model_name: 'ProductDesign',
    column_type: 'decimal',
    label_key_path: 'productDesign.inspectionFee',
  },
  cost_price: {
    model_name: 'ProductDesign',
    column_type: 'decimal',
    label_key_path: 'productDesign.costPrice',
  },
  fabric_settlement_cost: {
    model_name: 'ProductDesign',
    column_type: 'decimal',
    label_key_path: 'productDesign.fabricSettlementCost',
  },
  craft_settlement_cost: {
    model_name: 'ProductDesign',
    column_type: 'decimal',
    label_key_path: 'productDesign.craftSettlementCost',
  },
  processing_settlement_cost: {
    model_name: 'ProductDesign',
    column_type: 'decimal',
    label_key_path: 'productDesign.processingSettlementCost',
  },
  assist_settlement_cost: {
    model_name: 'ProductDesign',
    column_type: 'decimal',
    label_key_path: 'productDesign.assistSettlementCost',
  },
  management_settlement_cost: {
    model_name: 'ProductDesign',
    column_type: 'decimal',
    label_key_path: 'productDesign.managementSettlementCost',
  },
  settlement_cost: {
    model_name: 'ProductDesign',
    column_type: 'decimal',
    label_key_path: 'productDesign.settlementCost',
  },
  overdue_state: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.overdueState',
  },
  plate_making_type: {
    model_name: 'ProductDesign',
    column_type: 'enum',
    extra: {
      options: ['original', 'reproduction', 'pre_production', 'fabric_craft', 'paper_pattern', 'pre_quotation'],
    },
    label_key_path: 'productDesign.plateMakingType',
  },
  accessory_state: {
    model_name: 'ProductDesign',
    column_type: 'enum',
    extra: {
      options: ['unknown', 'needless', 'pending', 'confirmed', 'completed'],
    },
    label_key_path: 'productDesign.accessoryState',
  },
  fabric_complated: {
    model_name: 'ProductDesign',
    column_type: 'boolean',
    label_key_path: 'productDesign.fabricComplated',
  },
  accessory_complated: {
    model_name: 'ProductDesign',
    column_type: 'boolean',
    label_key_path: 'productDesign.accessoryComplated',
  },
  purchaser: {
    model_name: 'ProductDesign',
    column_type: 'belongs_to',
    label_key_path: 'productDesign.purchaser',
    extra: {
      association_name: 'purchaser',
      model_name: 'User',
      foreign_key: 'purchaser_id',
      display_column: 'screen_name',
    },
  },
  purchaser_id: {
    model_name: 'ProductDesign',
    column_type: 'belongs_to',
    label_key_path: 'productDesign.purchaser',
    extra: {
      association_name: 'purchaser',
      model_name: 'User',
      foreign_key: 'purchaser_id',
      display_column: 'screen_name',
    },
  },
  customer_name: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.customerName',
  },
  fabric_state: {
    model_name: 'ProductDesign',
    column_type: 'enum',
    extra: {
      options: ['unknown', 'needless', 'pending', 'confirmed', 'completed'],
    },
    label_key_path: 'productDesign.fabricState',
  },
  fabric_purchaser: {
    model_name: 'ProductDesign',
    column_type: 'belongs_to',
    label_key_path: 'productDesign.fabricPurchaser',
    extra: {
      association_name: 'fabric_purchaser',
      model_name: 'User',
      foreign_key: 'fabric_purchaser_id',
      display_column: 'screen_name',
    },
  },
  fabric_purchaser_id: {
    model_name: 'ProductDesign',
    column_type: 'belongs_to',
    label_key_path: 'productDesign.fabricPurchaser',
    extra: {
      association_name: 'fabric_purchaser',
      model_name: 'User',
      foreign_key: 'fabric_purchaser_id',
      display_column: 'screen_name',
    },
  },
  receive_fabric_on: {
    model_name: 'ProductDesign',
    column_type: 'date',
    label_key_path: 'productDesign.receiveFabricOn',
  },
  main_image: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.mainImage',
  },
  product_design_item_table_attributes: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.productDesignItemTableAttributes',
  },
  confirm_accessory_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.confirmAccessoryRemark',
  },
  confirm_accessory_remark_images: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 20,
    },
    label_key_path: 'productDesign.confirmAccessoryRemarkImages',
  },
  confirm_accessory_remark_images_with_audio: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 20,
    },
    label_key_path: 'productDesign.confirmAccessoryRemarkImagesWithAudio',
  },
  confirm_fabric_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.confirmFabricRemark',
  },
  confirm_fabric_remark_images: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 20,
    },
    label_key_path: 'productDesign.confirmFabricRemarkImages',
  },
  confirm_fabric_remark_images_with_audio: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 20,
    },
    label_key_path: 'productDesign.confirmFabricRemarkImagesWithAudio',
  },
  receive_fabric_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.receiveFabricRemark',
  },
  receive_fabric_remark_images: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 20,
    },
    label_key_path: 'productDesign.receiveFabricRemarkImages',
  },
  receive_fabric_remark_images_with_audio: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 20,
    },
    label_key_path: 'productDesign.receiveFabricRemarkImagesWithAudio',
  },
  receive_fabric_and_assist_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.receiveFabricAndAssistRemark',
  },
  receive_fabric_and_assist_remark_images: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 20,
    },
    label_key_path: 'productDesign.receiveFabricAndAssistRemarkImages',
  },
  receive_fabric_and_assist_remark_images_with_audio: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 20,
    },
    label_key_path: 'productDesign.receiveFabricAndAssistRemarkImagesWithAudio',
  },
  cheif_pattern_making_officier_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.cheifPatternMakingOfficierRemark',
  },
  paper_pattern_files: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 20,
    },
    label_key_path: 'productDesign.paperPatternFiles',
  },
  paper_pattern_files_with_audio: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 20,
    },
    label_key_path: 'productDesign.paperPatternFilesWithAudio',
  },
  cost_detail_files: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 20,
    },
    label_key_path: 'productDesign.costDetailFiles',
  },
  cost_detail_files_with_audio: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 20,
    },
    label_key_path: 'productDesign.costDetailFilesWithAudio',
  },
  can_sales_director_approve: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canSalesDirectorApprove',
  },
  can_sales_director_reject: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canSalesDirectorReject',
  },
  can_sales_director_withdraw: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canSalesDirectorWithdraw',
  },
  can_reject: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canReject',
  },
  can_complete: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canComplete',
  },
  can_reject_make_plate: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canRejectMakePlate',
  },
  can_make_plate: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canMakePlate',
  },
  can_complete_make_plate: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canCompleteMakePlate',
  },
  can_cut: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canCut',
  },
  can_reject_cut: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canRejectCut',
  },
  can_craft: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canCraft',
  },
  can_complete_craft: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canCompleteCraft',
  },
  can_sew: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canSew',
  },
  can_reject_sew: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canRejectSew',
  },
  can_complete_sew: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canCompleteSew',
  },
  can_audit_quantity: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canAuditQuantity',
  },
  make_plate_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.makePlateRemark',
  },
  make_plate_remark_images: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 20,
    },
    label_key_path: 'productDesign.makePlateRemarkImages',
  },
  make_plate_remark_images_with_audio: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 20,
    },
    label_key_path: 'productDesign.makePlateRemarkImagesWithAudio',
  },
  can_update_make_plate_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canUpdateMakePlateRemark',
  },
  complete_make_plate_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.completeMakePlateRemark',
  },
  complete_make_plate_remark_images: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 20,
    },
    label_key_path: 'productDesign.completeMakePlateRemarkImages',
  },
  complete_make_plate_remark_images_with_audio: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 20,
    },
    label_key_path: 'productDesign.completeMakePlateRemarkImagesWithAudio',
  },
  can_update_complete_make_plate_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canUpdateCompleteMakePlateRemark',
  },
  cut_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.cutRemark',
  },
  cut_remark_images: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 20,
    },
    label_key_path: 'productDesign.cutRemarkImages',
  },
  cut_remark_images_with_audio: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 20,
    },
    label_key_path: 'productDesign.cutRemarkImagesWithAudio',
  },
  can_update_cut_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canUpdateCutRemark',
  },
  process_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.processRemark',
  },
  process_remark_images: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 20,
    },
    label_key_path: 'productDesign.processRemarkImages',
  },
  process_remark_images_with_audio: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 20,
    },
    label_key_path: 'productDesign.processRemarkImagesWithAudio',
  },
  can_update_process_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canUpdateProcessRemark',
  },
  complete_craft_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.completeCraftRemark',
  },
  complete_craft_remark_images: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 20,
    },
    label_key_path: 'productDesign.completeCraftRemarkImages',
  },
  complete_craft_remark_images_with_audio: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 20,
    },
    label_key_path: 'productDesign.completeCraftRemarkImagesWithAudio',
  },
  can_update_complete_craft_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canUpdateCompleteCraftRemark',
  },
  sewing_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.sewingRemark',
  },
  sewing_remark_images: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 20,
    },
    label_key_path: 'productDesign.sewingRemarkImages',
  },
  sewing_remark_images_with_audio: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 20,
    },
    label_key_path: 'productDesign.sewingRemarkImagesWithAudio',
  },
  can_update_sewing_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canUpdateSewingRemark',
  },
  complete_sewing_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.completeSewingRemark',
  },
  complete_sewing_remark_images: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 20,
    },
    label_key_path: 'productDesign.completeSewingRemarkImages',
  },
  complete_sewing_remark_images_with_audio: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 20,
    },
    label_key_path: 'productDesign.completeSewingRemarkImagesWithAudio',
  },
  can_update_complete_sewing_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canUpdateCompleteSewingRemark',
  },
  approve_plate_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.approvePlateRemark',
  },
  approve_plate_remark_images: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 20,
    },
    label_key_path: 'productDesign.approvePlateRemarkImages',
  },
  approve_plate_remark_images_with_audio: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 20,
    },
    label_key_path: 'productDesign.approvePlateRemarkImagesWithAudio',
  },
  can_update_approve_plate_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canUpdateApprovePlateRemark',
  },
  audit_quantity_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.auditQuantityRemark',
  },
  can_update_audit_quantity_remark: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.canUpdateAuditQuantityRemark',
  },
  abilities: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.abilities',
  },
  images: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 20,
    },
    label_key_path: 'productDesign.images',
  },
  images_with_audio: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 20,
    },
    label_key_path: 'productDesign.imagesWithAudio',
  },
  files: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 20,
    },
    label_key_path: 'productDesign.files',
  },
  files_with_audio: {
    model_name: 'ProductDesign',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 20,
    },
    label_key_path: 'productDesign.filesWithAudio',
  },
  craftsman: {
    model_name: 'ProductDesign',
    column_type: 'belongs_to',
    label_key_path: 'productDesign.craftsman',
    extra: {
      association_name: 'craftsman',
      model_name: 'User',
      foreign_key: 'craftsman_id',
      display_column: 'screen_name',
    },
  },
  craftsman_id: {
    model_name: 'ProductDesign',
    column_type: 'belongs_to',
    label_key_path: 'productDesign.craftsman',
    extra: {
      association_name: 'craftsman',
      model_name: 'User',
      foreign_key: 'craftsman_id',
      display_column: 'screen_name',
    },
  },
  sewer: {
    model_name: 'ProductDesign',
    column_type: 'belongs_to',
    label_key_path: 'productDesign.sewer',
    extra: {
      association_name: 'sewer',
      model_name: 'User',
      foreign_key: 'sewer_id',
      display_column: 'screen_name',
    },
  },
  sewer_id: {
    model_name: 'ProductDesign',
    column_type: 'belongs_to',
    label_key_path: 'productDesign.sewer',
    extra: {
      association_name: 'sewer',
      model_name: 'User',
      foreign_key: 'sewer_id',
      display_column: 'screen_name',
    },
  },
  valuer: {
    model_name: 'ProductDesign',
    column_type: 'belongs_to',
    label_key_path: 'productDesign.valuer',
    extra: {
      association_name: 'valuer',
      model_name: 'User',
      foreign_key: 'valuer_id',
      display_column: 'screen_name',
    },
  },
  valuer_id: {
    model_name: 'ProductDesign',
    column_type: 'belongs_to',
    label_key_path: 'productDesign.valuer',
    extra: {
      association_name: 'valuer',
      model_name: 'User',
      foreign_key: 'valuer_id',
      display_column: 'screen_name',
    },
  },
  operation_logs: {
    model_name: 'ProductDesign',
    column_type: 'has_many',
    label_key_path: 'productDesign.operationLogs',
    extra: {
      association_name: 'operation_logs',
      model_name: 'OperationLog',
      foreign_key: 'target_id',
      display_column: 'id',
    },
  },
  operation_log_ids: {
    model_name: 'ProductDesign',
    column_type: 'has_many',
    label_key_path: 'productDesign.operationLogs',
    extra: {
      association_name: 'operation_logs',
      model_name: 'OperationLog',
      foreign_key: 'target_id',
      display_column: 'id',
    },
  },
  state_operation_logs: {
    model_name: 'ProductDesign',
    column_type: 'has_many',
    label_key_path: 'productDesign.stateOperationLogs',
    extra: {
      association_name: 'state_operation_logs',
      model_name: 'OperationLog',
      foreign_key: 'target_id',
      display_column: 'id',
    },
  },
  state_operation_log_ids: {
    model_name: 'ProductDesign',
    column_type: 'has_many',
    label_key_path: 'productDesign.stateOperationLogs',
    extra: {
      association_name: 'state_operation_logs',
      model_name: 'OperationLog',
      foreign_key: 'target_id',
      display_column: 'id',
    },
  },
  accessory_state_operation_logs: {
    model_name: 'ProductDesign',
    column_type: 'has_many',
    label_key_path: 'productDesign.accessoryStateOperationLogs',
    extra: {
      association_name: 'accessory_state_operation_logs',
      model_name: 'OperationLog',
      foreign_key: 'target_id',
      display_column: 'id',
    },
  },
  accessory_state_operation_log_ids: {
    model_name: 'ProductDesign',
    column_type: 'has_many',
    label_key_path: 'productDesign.accessoryStateOperationLogs',
    extra: {
      association_name: 'accessory_state_operation_logs',
      model_name: 'OperationLog',
      foreign_key: 'target_id',
      display_column: 'id',
    },
  },
  fabric_state_operation_logs: {
    model_name: 'ProductDesign',
    column_type: 'has_many',
    label_key_path: 'productDesign.fabricStateOperationLogs',
    extra: {
      association_name: 'fabric_state_operation_logs',
      model_name: 'OperationLog',
      foreign_key: 'target_id',
      display_column: 'id',
    },
  },
  fabric_state_operation_log_ids: {
    model_name: 'ProductDesign',
    column_type: 'has_many',
    label_key_path: 'productDesign.fabricStateOperationLogs',
    extra: {
      association_name: 'fabric_state_operation_logs',
      model_name: 'OperationLog',
      foreign_key: 'target_id',
      display_column: 'id',
    },
  },
  normal_operation_logs: {
    model_name: 'ProductDesign',
    column_type: 'has_many',
    label_key_path: 'productDesign.normalOperationLogs',
    extra: {
      association_name: 'normal_operation_logs',
      model_name: 'OperationLog',
      foreign_key: 'target_id',
      display_column: 'id',
    },
  },
  normal_operation_log_ids: {
    model_name: 'ProductDesign',
    column_type: 'has_many',
    label_key_path: 'productDesign.normalOperationLogs',
    extra: {
      association_name: 'normal_operation_logs',
      model_name: 'OperationLog',
      foreign_key: 'target_id',
      display_column: 'id',
    },
  },
  orders_latest_ai_file_url: {
    model_name: 'ProductDesign',
    column_type: 'string',
    label_key_path: 'productDesign.ordersLatestAiFileUrl',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
